// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  duelsWon: __t.u32().name("duels_won"),
  duelsLost: __t.u32().name("duels_lost"),
  duelsDrawn: __t.u32().name("duels_drawn"),
  matchesWon: __t.u32().name("matches_won"),
  matchesLost: __t.u32().name("matches_lost"),
  matchesDrawn: __t.u32().name("matches_drawn"),
  objectives: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
